import { render, staticRenderFns } from "./JPopup.vue?vue&type=template&id=678e2f69&scoped=true"
import script from "./JPopup.vue?vue&type=script&lang=js"
export * from "./JPopup.vue?vue&type=script&lang=js"
import style0 from "./JPopup.vue?vue&type=style&index=0&id=678e2f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e2f69",
  null
  
)

export default component.exports